import api from './api';

export const getPurchaseSites = async (params = {}) => {
  const response = await api.get('/configuration/purchase-sites', { params });
  return response.data;
};

export const getPurchaseSite = async (id) => {
  const response = await api.get(`/configuration/purchase-sites/${id}`);
  return response.data;
};

export const createPurchaseSite = async (data) => {
  const response = await api.post('/configuration/purchase-sites', data);
  return response.data;
};

export const updatePurchaseSite = async (id, data) => {
  const response = await api.put(`/configuration/purchase-sites/${id}`, data);
  return response.data;
};

export const deletePurchaseSite = async (id) => {
  const response = await api.delete(`/configuration/purchase-sites/${id}`);
  return response.data;
};
